import { PointLight, Object3D, Vector3 } from "three";
import Loader from "../Loader";
import World from "../World";

class Torch {
    public world: World;

    public targetLightIntensity: number;

    public torchlight: PointLight;

    public model: Object3D | null = null;

    constructor(loader: Loader, world: World) {
        this.world = world;
        this.targetLightIntensity = 1;
        this.torchlight = new PointLight(0xffff00, 1, 6);
        setInterval(() => {
            this.targetLightIntensity = Math.random() / 4 + 0.75;
            return this.targetLightIntensity;
        }, 100);
        loader.loadModel(
            `${process.env.ASSET_URL}/models/torch.dae`,
            (model: Object3D) => {
                this.model = model;

                this.model.name = "torch";
                const size = 0.2;
                this.model.add(this.torchlight);
                this.torchlight.position.set(0, 1.2, 0);
                this.model.position.set(0.2, -0.2, -0.4);
                this.model.scale.set(size, size, size);
                this.model.rotation.set(-Math.PI * 0.1, Math.PI / 2, 0);
            }
        );
    }

    public update(): void {
        this.fire();
    }

    public fire(): void {
        this.createParticles();
        this.torchlight.intensity +=
            (this.targetLightIntensity - this.torchlight.intensity) * 0.3;
    }

    public createParticles(): void {
        const { /* world, */ torchlight } = this;
        const vector: Vector3 = new Vector3(0, 0.3, -0.1);
        if (torchlight) {
            vector.setFromMatrixPosition(torchlight.matrixWorld);
        }
        for (let i = 0; i < 1; i += 1) {
            /* world.particleSystem.spawnParticle({
        position: vector,
        positionRandomness: 0,
        velocity: new Vector3(0, 0.3, 0),
        velocityRandomness: 0.3,
        color: 0xcc3300,
        colorRandomness: 0.3,
        turbulence: 0,
        lifetime: 0.1,
        size: 500,
        sizeRandomness: 100
      }); */
        }
    }
}

export default Torch;
